@if (url) {
  <a
    class="thumbnail-link"
    [href]="url"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img class="thumbnail" [src]="url" [alt]="alt" />
  </a>
}
